import axios from "axios";

export const getPublicRequestError = (
  status: number,
  retryAfter?: string | null,
  fallback = "Unable to process your request. Please try again.",
): string => {
  if (status === 429) {
    const seconds =
      retryAfter && /^\d+$/.test(retryAfter) ? Number(retryAfter) : 0;
    return seconds > 0
      ? `Too many requests. Please try again in ${seconds} seconds.`
      : "Too many requests. Please wait a minute before trying again.";
  }
  if (status === 413)
    return "Your submission is too large. Please reduce its size and try again.";
  return fallback;
};

export const getPublicApiError = (error: unknown, fallback: string): string =>
  axios.isAxiosError(error)
    ? getPublicRequestError(
        error.response?.status ?? 0,
        error.response?.headers?.["retry-after"],
        fallback,
      )
    : fallback;
